(function ($) {

	$(document).gp_ready(init_dropdown)

	function init_dropdown() {
		$('.filter-dropdown .control-button').off("click").click(function () {
			let $filter = $(this).closest('.filter-dropdown')
			toggle_dropdown($filter)
		})
	}

	function toggle_dropdown($filter) {
		if (!$filter.hasClass('opened')) {
			open_dropdown($filter)
		} else {
			close_dropdown($filter)
		}
	}

	function open_dropdown($filter) {

		// Trigger open dropdown to be able to stop it for phones and open modal insteal
		let data = {
			filter: $filter.data('filter'),
			open_dropdown: true
		}
		$(document).trigger('open_filter_dropdown', data)

		if (data.open_dropdown) {
			$('body').trigger('show_overlay')
			$filter.addClass('opened');
			$filter.children('.filter-dropdown__content').slideDown(200);
		}
	}

	function close_dropdown($filter) {
		$('body').trigger('hide_overlay');
		$filter.removeClass('opened');
		$filter.children('.filter-dropdown__content').slideUp(200);
	}

	// Close filter on body overlay click
	$(document).on("click", "", function (e) {
		if (!e.target.closest(".filter-dropdown")) {
			close_dropdown($(".filter-dropdown"))
		}
	})

	// Close modal on Escape
	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			close_dropdown($('.filter-dropdown'))
		}
	});

})(jQuery);